import type { IClient } from "./ClientService";

export interface ClientFinance {
	traffic: {
		attempts: number;
		completed: number;
		failed: number;
		by_status: Record<string, number>;
		conversion: number | null;
		conversion_settled: number | null;
		last_activity_at: string | null;
		silent_days: number | null;
	};
	money: Record<string, { turnover: number; revenue: number; acquirer_cost: number; profit: number }>;
	rollings: Record<string, { taken: number; released: number }>;
}

export interface ClientListPage {
	items: IClient[];
	total: number;
	page: number;
	per_page: number;
	truncated: boolean;
	finance?: {
		period: { from: string; to: string; days: number };
		money_complete_through: string | null;
		notes: string[];
		degraded: unknown[];
	};
}

export const getClientListPage = (data: unknown): ClientListPage | null => {
	// HTTP normally unwraps the API envelope; also accept the supplied { data } form.
	if (data && typeof data === "object" && "data" in data && !("items" in data)) data = data.data;
	// Retain compatibility with older responses during rollout.
	if (Array.isArray(data)) return { items: data, total: data.length, page: 0, per_page: Math.max(1, data.length), truncated: false };
	if (!data || typeof data !== "object") return null;
	const value = data as ClientListPage;
	if (!Array.isArray(value.items) || !Number.isSafeInteger(value.total) || value.total < 0 ||
		!Number.isSafeInteger(value.page) || value.page < 0 || !Number.isSafeInteger(value.per_page) || value.per_page < 1 ||
		typeof value.truncated !== "boolean") return null;
	return value;
};

// clients/list now wraps its rows with pagination and finance metadata.
export const getClientListItems = (data: unknown): IClient[] | null => {
	if (Array.isArray(data)) return data;
	if (data && typeof data === "object" && "items" in data && Array.isArray(data.items)) return data.items;
	return null;
};
